import React, {Component} from 'react';
import AccumulatedOptimizationCategories from "../components/tables/accumulatedOptimizationCategories";
import AccumulatedOptimizationCategoriesGraph from "../charts/accumulatedOptimizationCategoriesGraph"

import * as dataService from "../service/data-info-chart/requestsUtil"
import {OPTIMIZATION_MONITORING, ACCUMULATED_OPTIMIZATION_CATEGORIES, WHITOUT_INFORMATION} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";

var Loader = require('react-loader');

class AccumulatedOptimizationCategoriesComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {data: [], loaded: false}
  }

  componentDidMount() {
    dataService.getFetch(OPTIMIZATION_MONITORING + cbu.checkBusinessUnit(this.props.bu) + ACCUMULATED_OPTIMIZATION_CATEGORIES)
      .then((json) => {
        this.setState({data: json, loaded: true})
      });
  }

  render() {
    if (this.state.data.length > 0) {
      return (
        <div>
          <AccumulatedOptimizationCategories striped={true} data={this.state.data}/>
          <AccumulatedOptimizationCategoriesGraph data={this.state.data}/>
        </div>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }


  }
}

export default AccumulatedOptimizationCategoriesComponent;




// WEBPACK FOOTER //
// ./src/components/accumulatedOptimizationCategoriesComponent.js